<template>
  <div>
    <div style="display:flex;justify-content:center;align-items:center;">
      <p style="color: #13305D;font-weight: bold;margin-top: 20px;font-size: 2rem">Statistics</p>
    </div>

    <p style="font-size: 20px;margin-left: 50px;margin-right: 50px;margin-top: 10px">We provide statistics information about the distribution of entries collected in RNAPhaSep, entries are clasified by RNA type, RNA source, component of LLPS and in vivo/vitro. As of June 2021, our database includes 1113 entries, to reduce the data redundancy, we consolidated the entries with RNA-related information and protein name, and collated 628 unique RNAPSID records.</p>
    <el-row :gutter="1" style="padding-top: 20px" type="flex" class="row-bg" justify="center">

      <el-row :gutter="1" style="margin-top: 10px">
        <div id="main1" style="width: 600px;height:400px;"></div>
        <div id="main2" style="width: 600px;height:400px;"></div>
        <div id="main6" style="width: 600px;height:400px;"></div>

      </el-row>

      <el-row :gutter="1" style="margin-top: 10px">
        <div id="main3" style="width: 600px;height:400px;"></div>
        <div id="main4" style="width: 600px;height:400px;"></div>
        <div id="main5" style="width: 500px;height:400px;margin-left: 50px"></div>
      </el-row>



    </el-row>
    <div style="display:flex;justify-content:center;align-items:center;margin-top: 20px;margin-bottom: 20px">
      <div id="main7" style="width: 600px;height:400px;"></div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Statistics",
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted(){
    this.drawLine();
  },
  methods: {
    drawLine(){

      let myChart1 = this.$echarts.init(document.getElementById('main1'))
      let myChart2 = this.$echarts.init(document.getElementById('main2'))
      let myChart3 = this.$echarts.init(document.getElementById('main3'))
      let myChart4 = this.$echarts.init(document.getElementById('main4'))

      let myChart5 = this.$echarts.init(document.getElementById('main5'))
      let myChart6 = this.$echarts.init(document.getElementById('main6'))
      let myChart7 = this.$echarts.init(document.getElementById('main7'))
      // 绘制图表

      var data3 = [{value: 278 ,name:' In vivo'},{value: 835 ,name:' In vitro'}];
      var data4 = [{value: 249 ,name:'Unknown(249)'},{value: 10 ,name:'solute(10)'},{value: 10 ,name:'liquid(10)'},{value: 8 ,name:'gel(8)'},{value: 1 ,name:'solid(1)'},
        {value: 43 ,name:'Unknown(43)'},{value: 124 ,name:'solute(124)'},{value: 501 ,name:'liquid(501)'},{value: 28 ,name:'gel(28)'},{value: 23 ,name:'solid(23)'},{value: 116 ,name:'multistate(116)'}];

      myChart1.setOption( {
        title: {
          text: 'RNA species',
          // subtext: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },

        series: [
          {
            type: 'pie',
            radius: '60%',
            data: [
              {value: 18 ,name:' Caenorhabditis elegans(18)'},{value: 6 ,name:' Drosophila melanogaster(6)'},{value: 192 ,name:' Homo sapiens(192)'},{value: 22 ,name:' Mus musculus(22)'},{value: 17 ,name:' Other Species(17)'},{value: 4 ,name:' Photinus pyralis(4)'},{value: 3 ,name:' Rattus norvegicus(3)'},{value: 8 ,name:' Saccharomyces cerevisiae(8)'},{value: 3 ,name:' Spathaspora passalidarum(3)'},{value: 3 ,name:' Triticum aestivum(3)'},{value: 44 ,name:' Virus(44)'},{value: 3 ,name:' Xenopus laevis(3)'},{value: 3 ,name:' Zea mays(3)'}
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });

      myChart2.setOption( {
        title: {
          text: 'Designed RNA',
          // subtext: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        // legend: {
        //     orient: 'vertical',
        //     left: 'left',
        // },
        series: [
          {

            type: 'pie',
            radius: '60%',
            data: [
              {value: 28 ,name:' repeat RNA(28)'},{value: 41 ,name:' poly RNA(41)'},{value: 24 ,name:' irregular RNA(24)'},{value: 11 ,name:' nucleotide rich RNA(11)'}
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });

      myChart3.setOption(  {
        title: {
          text: 'Natural RNA',
          // subtext: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        // legend: {
        //     orient: 'vertical',
        //     left: 'left',
        // },
        series: [
          {

            type: 'pie',
            radius: '60%',
            data: [
              {value: 78 ,name:' lncRNA(78)'},{value: 28 ,name:' miRNA(28)'},{value: 123 ,name:' mRNA(123)'},{value: 4 ,name:' piRNA(4)'},{value: 15 ,name:' rRNA(15)'},{value: 3 ,name:' siRNA(3)'},{value: 6 ,name:' snoRNA(6)'},{value: 2 ,name:' snRNA(2)'},{value: 13 ,name:' total RNA(13)'},{value: 5 ,name:' tRNA(5)'},{value: 44 ,name:' virus RNA(44)'}
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });

      myChart4.setOption(  {
        title: {
          text: 'Component type of entries',
          // subtext: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
        },


        series: [
          {

            type: 'pie',
            selectedMode: 'single',
            radius: [0, '25%'],
            label: {
              position: 'inner',
              fontSize: 14,
            },
            labelLine: {
              show: false
            },
            data: [
              {value: 278 ,name:' In vivo'},{value: 835 ,name:' In vitro'}
            ]
          },
          {

            type: 'pie',
            radius: ['35%', '60%'],
            labelLine: {
              length: 30,
            },

            data: [
              {value: 278 ,name:' undefined(278)'},{value: 30 ,name:' RNA (30)'},{value: 549 ,name:' RNA + protein (549)'},{value: 59 ,name:' RNA + proteins (59)'},{value: 14 ,name:' RNAs (14)'},{value: 158 ,name:' RNAs + protein (158)'},{value: 25 ,name:' RNAs + proteins (25)'}

        ]
          }
        ]
      });

      myChart5.setOption(
           {
             title: {
               text: 'Percentage of ribonucleotides in vitro',
               // subtext: '',
               left: 'center'
             },
            tooltip: {
              trigger: 'axis',
              axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            textStyle:{
              fontSize:18,
              fontWeight:300
            },
            legend: {
              data: [ 'A', 'U', 'G', 'C'],
              top:"6%"
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [
              {

                type: 'category',
                data: ['ALL', 'Natural RNA', 'Designed RNA']
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                name: 'C',
                type: 'bar',
                stack: '1',
                width:'60%',
                height:'40%',
                barWidth:100,
                emphasis: {
                  focus: 'series'
                },
                data: [56048/265694, 52664/251991, 2744/11681]
              },
              {
                name: 'G',
                type: 'bar',
                stack: '1',
                emphasis: {
                  focus: 'series'
                },
                data: [54772/265694, 53062/251991, 1037/11681]
              },
              {
                name: 'U',
                type: 'bar',
                stack: '1',
                emphasis: {
                  focus: 'series'
                },
                data: [77789/265694, 73089/251991, 4181/11681]
              },
              {
                name: 'A',
                type: 'bar',
                stack: '1',
                emphasis: {
                  focus: 'series'
                },
                data: [77085/265694, 73176/251991,3719/11681]
              }
            ]
          }
      );
      myChart6.setOption(
          {
            tooltip: {
              trigger: 'item',

            },
            title: {
              text: 'Distribution of morphology',
              left:'center'


            },
            legend: {
              data: ['line']
            },
            textStyle: {
              fontSize: 14,
              fontWeight: 300
            },

            series: [
              {
                type: 'pie',
                selectedMode: 'single',
                radius: [0, '25%'],
                label: {
                  position: 'inner',
                  fontSize: 14,
                },
                labelLine: {
                  show: false
                },
                data: data3
              },
              {

                type: 'pie',
                radius: ['35%', '60%'],
                labelLine: {
                  length: 30,
                },

                data: data4
              },
            ]
          }



      )
      myChart7.setOption(
          {
            title: {
              text: 'Distribution of RNAs length in vitro',
              // subtext: '',
              left: 'center'
            },

              legend:{
                data: ['ALL','Natural RNA','Designed RNA'],

                top :'6%',
                textStyle: { //图例文字的样式

                  fontSize: 16
                },

              },
              tooltip: {},
              textStyle:{
                fontSize:25,
                fontWeight:300
              },
              xAxis: [
                {type: 'category',data: ['1~20','21~50','51~100','101~1000','1001~2000','2001~3000','3001~5000','>5000'], gridIndex: 0},
                {type: 'category',data: ['1~20','21~50','51~100','101~1000','1001~2000','2001~3000','3001~5000','>5000'], gridIndex: 1},
                {type: 'category', data: ['1~20','21~50','51~100','101~1000','1001~2000','2001~3000','3001~5000','>5000'],gridIndex: 2},

              ],
              yAxis: [
                {gridIndex: 0},
                {gridIndex: 1},
                {gridIndex: 2}
              ],
              grid: [
                {top:'13%',bottom: '65%'},
                {top: '40%',bottom:'35%'},
                {top:'70%',bottom:'5%'}
              ],
              series: [
                // These series are in the first grid.
                {name:'ALL',type: 'bar', seriesLayoutBy: 'column', data: [13,29,14,43,52,8,16,8],barWidth:60},
                // These series are in the second grid.
                {name:'Natural RNA',type: 'bar', seriesLayoutBy: 'column', xAxisIndex: 1, yAxisIndex: 1,data:[2,5,2,33,51,6,16,8],barWidth:60},
                //These series are in the third grid
                {name:'Designed RNA',type: 'bar', seriesLayoutBy: 'column',xAxisIndex: 2, yAxisIndex: 2,data: [11,24,12,10,1,2,0,55],barWidth:60},
              ]


          }
      )
    }
  }
}
</script>

<style scoped>
p{
  margin-top: 0px;
  margin-bottom:  5px;
  margin-left: 40px;
}
a{
  text-decoration: none;
}
</style>